<template>
  <div class="container mt-4">
    <!-- ÍCONES HEADER -->
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
      <div>
        <h4 class="fw-bold text-uppercase text-primary mb-1">REPASSES</h4>
        <small class="text-muted">
          <strong>Pasta:</strong> {{ pasta }} |
          <strong>Referência do Imóvel:</strong> {{ locacao.LOC_IMOVEL || '---' }}
        </small>
      </div>
      </div>


  <!-- Ícones de navegação -->
    <div class="row mb-4 text-center">
      <div class="col" v-for="icon in icones" :key="icon.label">
        <router-link :to="`${icon.rota}/${pasta}`">
          <img :src="icon.img" class="icon-menu" />
          <p class="black">{{ icon.label }}</p>
        </router-link>
      </div>
    </div>


    <!-- HEADER -->
    <div class="card shadow-sm p-4 mb-4">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div>
          <h5 class="fw-bold text-primary mb-0">Informações do Repasse</h5>
          <small class="text-muted">
            <strong>Locador:</strong> {{ locacao.LOC_LOCADOR || '---' }}
          </small>
        </div>

        <div class="d-flex align-items-center gap-3">
          <span
            class="badge fs-5 text-light px-4 py-2 shadow-sm"
            :class="{
              'bg-success': ultimoBoleto.pago == 1,
              'bg-danger': ultimoBoleto.pago != 1
            }"
          >
            {{ ultimoBoleto.pago == 1 ? 'Último boleto pago' : 'Nenhum pagamento confirmado' }}
          </span>
         <!-- <button class="btn btn-secondary" @click="$router.go(-1)">⬅ Voltar</button> -->
        </div>
      </div>

      <hr />

      <div class="row mt-2">
        <div class="col-md-6">
          <h6 class="fw-bold text-primary">Dados do Locador</h6>
          <p><strong>Nome:</strong> {{ locacao.LOC_LOCADOR || '---' }}</p>
          <p><strong>Telefone 1:</strong> {{ locacao.LOC_LOCADOR_TELEFONE1|| '---' }}</p>
          <p><strong>Telefone 2:</strong> {{ locacao.LOC_LOCADOR_TELEFONE2|| '---' }}</p>
          <p><strong>Email:</strong> {{ locacao.LOC_LOCADOR_EMAIL || '---' }}</p>
          <p><strong>Outras informações:</strong> {{ locacao.LOC_LOCADOR_OBS || '---' }}</p>
        </div>

        <div class="col-md-6">
          <h6 class="fw-bold text-primary">Chave PIX</h6>
          <p><strong>Tipo:</strong> {{ locacao.LOC_PIX || '---' }}</p>
          <p><strong>Chave:</strong> {{ locacao.LOC_REPASSE || '---' }}</p>
        </div>
      </div>

      <hr />

      <div class="text-center mt-3">
        <h5 class="fw-bold text-success">Valor a ser repassado ao locador:</h5>
        <h2 class="fw-bold text-success">{{ formatarMoeda(valorRepasse) }}</h2>
        <h2 class="fw-bold text-success"> <input style="width:200px;display:block;margin: 0 auto;" type="text" v-model="valorRepasse" v-money="money" class="form-control" /></h2>
        <p class="text-muted">
          Total do último boleto pago - Valor de Administração - Taxa boleto
        </p>
      </div>
    </div>

    <!-- GERAR PIX -->
    <div class="text-center mb-4">
      <div class="mb-3">
        <label class="fw-bold me-2">Tipo de saída:</label>
        <select v-model="tipoSaida" class="form-select d-inline w-auto">
          <option value="qr">QR Code</option>
          <option value="br">BR Code</option>
        </select>
      </div>

      <button class="btn btn-primary px-5 py-2 fw-bold" @click="gerarPix">
        💰 Gerar Pix
      </button>
    </div>

    <!-- RESULTADO PIX -->
    <div class="text-center my-4" v-if="qrCodeUrl || brCode">
      <div v-if="qrCodeUrl">
        <img :src="qrCodeUrl" alt="QR Code Pix" class="img-fluid shadow mt-3" style="max-width:300px;">
      </div>

      <div v-else class="mt-3">
       <textarea class="form-control text-center fw-bold" rows="3"  v-text="brCode"></textarea>

        <button class="btn btn-outline-secondary mt-2" @click="copiarBrCode">Copiar</button>
      </div>

      <button class="btn btn-success mt-4 px-5 py-2 fw-bold" @click="confirmarRepasse">
        Confirmar
      </button>
    </div>

    <!-- LISTAGEM DE REPASSES -->
    <div class="card mt-5 p-3 shadow-sm">
      <h5 class="fw-bold text-primary mb-3">Histórico de Repasses</h5>

     <table class="table table-bordered table-striped align-middle text-center shadow-sm">
  <thead class="table-light">
    <tr>
      <th>Data do Repasse</th>
      <th>Valor</th>
      <th>Relatório Enviado</th>
      <th>Ações</th>
    </tr>
  </thead>
  <tbody>
    <tr v-if="repasses.length === 0">
      <td colspan="4" class="text-muted">Nenhum repasse registrado ainda.</td>
    </tr>
    <tr v-for="r in repasses" :key="r.id">
      <td>{{ formatarDataBR(r.data_repasse) }}</td>
      <td>R$ {{ formatarMoeda(r.valor_repasse) }}</td>
      <td>{{ r.relatorio_enviado == 1 ? 'Sim' : 'Não' }}</td>
      <td>
        <button class="btn btn-sm btn-primary me-2 mx-2">Visualizar</button>
        <button class="btn btn-sm btn-warning mx-2">Enviar Relatório</button>
        <button class="btn btn-sm btn-danger me-2 mx-2">Excluir</button>
        
      </td>
    </tr>
  </tbody>
</table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VMoney } from "v-money";
export default {
  directives: { money: VMoney },
  data() {
    return {
       money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
      },
      baseUrl: "https://www2.royaljardim.com.br/sistema/",
      pasta: "",
      locacao: {},
      ultimoBoleto: {},
      valorRepasse: 0,
      tipoSaida: "qr",
      qrCodeUrl: "",
      brCode: "",
      repasses: [],
       icones: [
        { label: "FICHA", img: "/img/ficha.png", rota: "/locacao" },
        { label: "BOLETOS", img: "/img/boletos.png", rota: "/boletos" },
        { label: "REPASSES", img: "/img/repasses.png", rota: "/repasses" },
        { label: "IPTU", img: "/img/iptu.png", rota: "/iptuClientes" },
          { label: "SEGURO", img: "/img/seguro.png", rota: "/seguroFianca" },
        { label: "RELATÓRIOS", img: "/img/relatorios.png", rota: "/relatorios" },
      ],
    };
  },
  mounted() {
    this.pasta = this.$route.params.id;
    this.carregarDados();
    this.listarRepasses();
  },
  methods: {
    async carregarDados() {
      try {
        const res = await axios.post(this.baseUrl + "repasses", new URLSearchParams({
          acao: "carregar",
          pasta: this.pasta,
        }));
        const dados = res.data;
        this.locacao = dados.locacao || {};
        this.ultimoBoleto = dados.boleto || {};
        this.valorRepasse =
          (parseFloat(this.ultimoBoleto.valor_total) || 0) -
           (parseFloat(this.ultimoBoleto.valor_taxa_boleto) || 0) -
          (parseFloat(this.locacao.LOC_VALOR_ADM) || 0);
      } catch (e) {
        console.error("Erro ao carregar dados:", e);
      }
    },

   async gerarPix() {
    
  try {
    const payload = new FormData();
    payload.append("nome", this.locacao.LOC_LOCADOR);
    payload.append("cidade", "Santo André");
    payload.append("valor", this.valorRepasse.replace(/[R$\s.]/g, "").replace(",", "."));
    payload.append("saida", this.tipoSaida);
    payload.append("chave", this.locacao.LOC_REPASSE.replace(".", "").replace(".", "").replace("-", ""));
    payload.append("txid", "Repasse");

    const response = await axios.post(`${this.baseUrl}Repasses/gerar_pix`, payload);
    console.log(response);

    if (response.data.type === "qr") {
      // exibe o QR Code
      this.qrCodeUrl = `data:image/png;base64,${response.data.data}`;
      this.brCode = null;
    } else if (response.data.type === "br") {
      // exibe o BR Code de texto
      const json = JSON.parse(response.data.data);
      this.brCode = json.brcode;
      this.qrCodeUrl = null;
    } else {
      alert("Erro ao gerar Pix. Verifique os dados e tente novamente.");
    }
  } catch (error) {
    console.error("Erro ao gerar Pix:", error);
    alert("Falha ao gerar Pix. Tente novamente mais tarde.");
  }
},

    async confirmarRepasse() {
      try {
        await axios.post(this.baseUrl + "repasses", new URLSearchParams({
          acao: "salvar",
          pasta: this.pasta,
          id_boleto: this.ultimoBoleto.id,
          valor: this.valorRepasse.replace(/[R$\s.]/g, "").replace(",", "."),
        }));
        alert("Repasse confirmado com sucesso!");
        this.listarRepasses();
      } catch (e) {
        console.error("Erro ao confirmar repasse:", e);
      }
    },

    async listarRepasses() {
      const res = await axios.post(this.baseUrl + "repasses", new URLSearchParams({
        acao: "listar",
        pasta: this.pasta,
      }));
      this.repasses = res.data || [];
    },

    async excluirRepasse(id) {
      if (confirm("Deseja excluir este repasse?")) {
        await axios.post(this.baseUrl + "repasses", new URLSearchParams({
          acao: "excluir",
          id: id,
        }));
        this.listarRepasses();
      }
    },

    async enviarRelatorio(id) {
      await axios.post(this.baseUrl + "repasses", new URLSearchParams({
        acao: "enviar_relatorio",
        id: id,
      }));
      alert("Relatório enviado ao locador!");
    },

    formatarMoeda(v) {
      return (v || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
     

    formatarDataBR(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split(" ")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },

    copiarBrCode() {
  try {
    // Verifica se o navegador suporta Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.brCode)
        .then(() => alert("BR Code copiado com sucesso!"))
        .catch(() => this.copiaAlternativa());
    } else {
      // Usa método alternativo se não estiver em contexto seguro
      this.copiaAlternativa();
    }
  } catch (err) {
    console.error("Erro ao copiar BR Code:", err);
    this.copiaAlternativa();
  }
},

copiaAlternativa() {
  // Cria elemento temporário
  const textarea = document.createElement("textarea");
  textarea.value = this.brCode;
  textarea.style.position = "fixed"; // evita rolagem
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    const sucesso = document.execCommand("copy");
    if (sucesso) alert("BR Code copiado com sucesso!");
    else alert("Não foi possível copiar o BR Code.");
  } catch (e) {
    alert("Seu navegador não permite copiar automaticamente.");
  }

  document.body.removeChild(textarea);
},

    visualizarRepasse(id) {
      alert("Visualização detalhada ainda não implementada. ID: " + id);
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 12px;
}
.icon-menu {
  width: 60px;
  height: 60px;
  cursor: pointer;
}  
.black{color:#000;}
</style>
